exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-title {\n  color: #A2A2A2;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-kanban/negocios-kanban-filters/negocios-kanban-filters.component.scss
// module id = ../../../../../src/app/components/negocios/negocios-kanban/negocios-kanban-filters/negocios-kanban-filters.component.scss
// module chunks = 0